import styled from 'styled-components'

interface StatusProps {
  status: 'pay' | 'waiting' | 'refused' | 'released'
}

interface IBlackProps {
  isBlack?: boolean
}

interface ProgressNumberProps {
  percentage: number
}

export const Container = styled.div`
  padding: 1rem;

  hr {
    border: none;
    border-top: 0.5px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  }

  h2 {
    font-size: 1.25rem;
    line-height: 1.6875rem;
    font-weight: 700;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
    margin-top: 1rem;
  }

  form {
    max-width: 700px;
  }

  @media only screen and (min-width: 900px) {
    padding-left: 300px;
  }
`

export const ConfirmButton = styled.button`
  background: ${({ theme }) => `rgb(${theme.primary.base})`};
  color: ${({ theme }) => `rgb(${theme.background.high})`};
  width: 100%;
  border: none;
  border-radius: 4px;
  padding: 1rem;

  margin: 0.5rem auto;

  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 700;

  &:disabled {
    background: ${({ theme }) => `rgba(${theme.primary.base}, 0.5)`};
    cursor: not-allowed;
  }
`

export const PayButton = styled.button`
  background: ${({ theme }) => `rgb(${theme.primary.base})`};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat';
  font-style: normal;
  color: ${({ theme }) => `rgb(${theme.background.high})`};
  width: 7.625rem;
  padding: 8px 12px;
  height: 32px;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 130%;
  font-weight: 500;

  &:disabled {
    background: ${({ theme }) => `rgba(${theme.primary.base}, 0.8)`};
    cursor: not-allowed;
  }
`

export const InputWrapper = styled.div`
  @media only screen and (min-width: 900px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`

export const PlanWrapper = styled.div`
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  max-width: 390px;
  margin: 1rem 0 1rem auto;

  strong {
    font-size: 3rem;
  }

  h3 {
    margin: 0;
    font-size: 1rem;
    line-height: 3.75rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-weight: 500;
  }
`

export const Wrapper = styled.div`
  table {
    display: block;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    border-collapse: collapse;

    tr {
      border-bottom: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
    }

    th {
      background: ${({ theme }) => `rgb(${theme.component.accent})`};
      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
      padding: 0.8rem;
    }

    td {
      padding: 1rem;
      font-weight: 500;
      font-size: 0.9rem;
      line-height: 1.25rem;
      text-align: center;
      max-width: 170px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-track {
      background: #fff;
    }
    ::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #333;
    }

    /* .onlyDesktop {
      @media only screen and (max-width: 900px) {
        display: none;
      }
    } */
  }
`

export const Status = styled.span<StatusProps>`
  background: ${(props) => {
    if (props.status === 'pay') return `rgb(${props.theme.green[700]})`
    if (props.status === 'waiting') return `rgb(${props.theme.blueHighlight[700]})`
    if (props.status === 'refused') return `rgb(${props.theme.red[700]})`
    if (props.status === 'released') return `rgb(${props.theme.purple[700]})`
  }};
  color: ${(props) => {
    if (props.status === 'pay') return `rgb(${props.theme.green[100]})`
    if (props.status === 'waiting') return `rgb(${props.theme.blueHighlight[100]})`
    if (props.status === 'refused') return `rgb(${props.theme.red[100]})`
    if (props.status === 'released') return `rgb(${props.theme.purple[100]})`
  }};
  padding: 2px 4px;
  border-radius: 1rem;
  font-weight: 700;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 5px;
  }
`

export const FaqWrapper = styled.div<IBlackProps>`
  padding: 1rem;
  background: ${({ theme }) => `rgb(${theme.background.low})`};
  border-radius: 8px;
  box-shadow: 0px 21px 34px -10px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 1.5rem 1rem;
  max-width: 822px;

  h2 {
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: 300;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  p {
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: 300;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    font-style: italic;
  }

  button {
    background: ${({ theme }) => `rgb(${theme.component.accent})`};
    padding: 0.3rem;
    border-radius: 4px;
    border: none;
    margin: auto 0.5rem auto 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }
`

export const WrapperFlex = styled.div`
  max-width: 800px;
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media only screen and (max-width: 1050px) {
    flex-direction: column-reverse;
  }
`

export const FormWrapper = styled.div`
  margin-top: 1.875rem;

  button {
    width: 100%;
    background: ${({ theme }) => `rgb(${theme.primary.base})`};
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    font-size: 1rem;
    line-height: 1.25rem;
    border: none;
    margin: 0.5rem 0;
    border-radius: 4px;
    padding: 1rem;
  }

  .ContactText {
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
  }
`
export const QuestionsWrapper = styled.div``

export const ButtonCont = styled.div`
  display: flex;
  flex-direction: row-reverse;

  p {
    font-size: 12px;
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    width: 200px;
  }

  button {
    width: 134px;
    height: 50px;
  }
`

export const ProgressBar = styled.div<ProgressNumberProps>`
  width: 100%;
  height: 6px;
  background-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};
  border-radius: 8px;

  &::before {
    content: '';
    display: block;

    border-radius: 8px;

    width: ${(props) => props.percentage && `${props.percentage}%`};
    height: 100%;

    background-color: #2b5cf3;

    animation: grow 1s ease-out;
  }
`
